<template>
  <div class="sidebar">
    <div class="search-container">
        <input type="text" placeholder="Search">
        <button><i class="fas fa-search"></i></button>
    </div>

    <ul class="sidebar-menu">
        <li class="section-title"><i class="fas fa-gamepad"></i> ALL SPORTS</li>
        <li v-for="sport in sports" :key="sport.id">
            {{ sport.name }}
        </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "SideBarOddsMatrix",
  computed: {
    ...mapGetters('oddsmatrix', ['getSports']),
    sports() {
      return this.getSports || [];
    },
  }
}
</script>

<style scoped>
/* 1200px 이상에서 숨김 */
@media (max-width: 1200px) {
  .sidebar {
    display: none !important;
  }
}
.sidebar {
    width: 300px;
    background-color: #1e1e1e;
    height: 100vh;
    padding: 15px;
    overflow-y: auto;
    flex-shrink: 0;
}

.main-wrapper {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.main-content {
    flex: 1;
    padding: 0;
    overflow-y: auto;
    height: 100vh;
}

.right-sidebar {
    width: 300px;
    background-color: #222;
    height: 100vh;
    padding: 15px;
    border-left: 1px solid #333;
    overflow-y: auto;
    flex-shrink: 0;
}

.search-container {
    display: flex;
    margin-bottom: 20px;
}

.search-container input {
    flex: 1;
    background-color: #333;
    border: none;
    padding: 10px;
    color: white;
    border-radius: 4px 0 0 4px;
}

.search-container button {
    background-color: #333;
    border: none;
    padding: 10px;
    color: #888;
    border-radius: 0 4px 4px 0;
}

.sidebar-menu {
    list-style: none;
}

.sidebar-menu li {
    padding: 15px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.sidebar-menu li i {
    margin-right: 10px;
    font-size: 18px;
    width: 25px;
    text-align: center;
}

.sidebar-menu .section-title {
    font-weight: bold;
    margin-top: 10px;
    color: white;
}

.sidebar-menu .game-item {
    padding: 10px 0;
}

.sidebar-menu .game-item img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

</style>
